
<p-table [value]="items" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines">
  <ng-template pTemplate="header">
    <tr>
      <th [width]="40" class="p-text-center">#</th>
      <th>{{ 'Loại yêu cầu'|translate }}</th>
      <th>Mã gói</th>
      <th>Tên gói</th>
      <th>Ngày yêu cầu</th>
      <th>Người yêu cầu</th>
      <th>Trạng thái</th>
      <th>Đã sử dụng</th>
      <th>Còn lại</th>
      <th>Ngày hiệu lực</th>
      <th>Ngày hết hạn</th>
      <th>Ghi chú</th>

    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-index="rowIndex">
    <tr>
      <td class="p-text-center">{{ (index + 1)|number }}</td>
      <td>{{ rowData['requestTypeEnum'] }}</td>
      <td>{{ rowData['productPseudoId'] }}</td>
      <td>{{ rowData['itemDescription'] }}</td>
      <td>{{ rowData['requestDate']|date:'dd/MM/yyyy' }}</td>
      <td>{{ rowData['filedByParty'] }}</td>
      <td>{{ rowData['status'] }}</td>
      <td>{{ rowData['usedQuantity'] }} </td>
      <td>{{ rowData['quantityOnHandTotal'] }} </td>
      <td>{{ rowData['receivedDate'] |date:'dd/MM/yyyy '}} </td>
      <td>{{ rowData['activationValidThru'] |date:'dd/MM/yyyy '}} </td>
      <td>{{ rowData['description'] }} </td>
    </tr>
  </ng-template>
</p-table>
